// Import utilities
import { recipeHasConditions } from '@automator/builder/_legacy/js/item/conditions/utilities';
import ConditionsBlock from '@automator/builder/_legacy/js/item/conditions/conditions-block';

/**
 * Renders conditions in the actions metabox
 */
export default class RenderConditions {
	/**
	 * Checks if the recipe has conditions and renders them
	 *
	 * @return {undefined}
	 */
	constructor() {
		// Check if the recipe has conditions
		if ( recipeHasConditions() ) {
			// Render conditions
			this.render();
		}
	}

	/**
	 * Renders the conditions
	 *
	 * @return {undefined}
	 */
	render() {
		// Iterate conditions
		Object.values( UncannyAutomator.recipe.conditions )
			// Render conditions with actions first, as we need some help from the other conditions blocks
			// to know where to render blocks without actions
			.sort( conditionsGroup => conditionsGroup.actions.length > 0 ? -1 : 1 )
			.forEach( ( conditionsGroup ) => {
				// Render only conditions groups that are direct children of the recipe
				if ( conditionsGroup.parentID !== UncannyAutomator._recipe.recipe_id ) {
					return;
				}

				// Create block of conditions
				new ConditionsBlock( {
					conditionsGroupId: conditionsGroup.id,
				} );
			} );
	}
}
